import { useMemo } from 'react';
import { toBool } from 'vopay';
import { TransactionsHistoryHostProps } from 'shared/transactionHistory';
import * as transactionDetailRoute from './transactionDetail.route';
import { useClientData } from '@/providers/ClientData.provider';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { usePermissions } from '@/providers/Permissions.provider';

// The one place client-dashboard maps its own user/account/permission model + detail route onto what the
// shared Transaction History feature takes as props (ID-13367). Used at the /transactions-history route
// mount (TransactionsHistoryPage) and by the Customer Activity tab; partner-dashboard writes its own
// equivalent from its own providers when it embeds the feature. Keep the three data kinds separate —
// viewer (person at the keyboard), account (facts about the account), userPermissions (role-based).
export default function useTransactionsHostProps(): TransactionsHistoryHostProps {
  const {
    response: { Country, SubAccountPermissions },
  } = useClientData();

  const {
    userSettings: { timezone },
  } = useUserSettingsProvider();

  const {
    permissions: { ViewSubaccounts },
  } = usePermissions();

  return useMemo(
    () => ({
      viewer: { timezone },
      account: { country: Country, subAccountPermissions: toBool(SubAccountPermissions) },
      userPermissions: { canViewSubaccounts: !!ViewSubaccounts },
      hostPaths: {
        transactionDetail: (transaction) =>
          transactionDetailRoute.getPath({
            transactionType: transaction.TransactionType,
            transactionID: transaction.TransactionID,
            currency: transaction.Currency,
          }),
      },
    }),
    [timezone, Country, SubAccountPermissions, ViewSubaccounts],
  );
}
